module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright-apply"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "sub-nav-wrapper"
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-01"
  }), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.$t('comb.accountRegister')))])]), _vm._v(" "), _c('span', [_vm._v("————————")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("————————")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "apply-wrapper"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.switchTabs
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "disabled": _vm.userType === 2,
      "label": _vm.$t('word.writer'),
      "name": "authorInfo"
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "authorInfo",
    attrs: {
      "model": _vm.authorInfo,
      "rules": _vm.authorRules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.realName'),
      "prop": "name",
      "required": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.realNamePlaceHolder')
    },
    model: {
      value: (_vm.authorInfo.name),
      callback: function($$v) {
        _vm.authorInfo.name = $$v
      },
      expression: "authorInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.IDNumber'),
      "prop": "id",
      "required": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.IDNumberPlaceHolder')
    },
    model: {
      value: (_vm.authorInfo.id),
      callback: function($$v) {
        _vm.authorInfo.id = $$v
      },
      expression: "authorInfo.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.phoneNumber'),
      "prop": "phoneNumber",
      "required": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.phoneNumberPlaceHolder')
    },
    model: {
      value: (_vm.authorInfo.phoneNumber),
      callback: function($$v) {
        _vm.authorInfo.phoneNumber = $$v
      },
      expression: "authorInfo.phoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.emailAddress'),
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.emailPlaceHolder')
    },
    model: {
      value: (_vm.authorInfo.email),
      callback: function($$v) {
        _vm.authorInfo.email = $$v
      },
      expression: "authorInfo.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.address'),
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": "您的联系地址"
    },
    model: {
      value: (_vm.authorInfo.address),
      callback: function($$v) {
        _vm.authorInfo.address = $$v
      },
      expression: "authorInfo.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('word.magnumOpus'),
      "prop": "curBook"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.bookBelongPlaceHolder')
    },
    model: {
      value: (_vm.authorInfo.curBook),
      callback: function($$v) {
        _vm.authorInfo.curBook = $$v
      },
      expression: "authorInfo.curBook"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('word.pseudonym'),
      "prop": "pseudonym"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('word.pseudonym')
    },
    model: {
      value: (_vm.authorInfo.pseudonym),
      callback: function($$v) {
        _vm.authorInfo.pseudonym = $$v
      },
      expression: "authorInfo.pseudonym"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('sen.uploadPictureWithLicence'),
      "required": true
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sen.pictureUploadLimit')))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "idPic"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "/api/upload/file",
      "type": "drag",
      "show-file-list": false,
      "before-upload": _vm.uploadBefore,
      "multiple": false,
      "v-model": _vm.authorInfo.idPic,
      "on-success": _vm.uploadSuccess
    }
  }, [(_vm.authorInfo.idPic) ? _c('img', {
    staticClass: "wrapper-upload-large",
    attrs: {
      "src": _vm.uploadedPic,
      "alt": ""
    }
  }) : _c('div', {
    staticClass: "wrapper-upload-large"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])]), _vm._v(" "), _c('el-card', {
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "example.png")
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verifyCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('word.verifyCode')
    },
    model: {
      value: (_vm.authorInfo.verifyCode),
      callback: function($$v) {
        _vm.authorInfo.verifyCode = $$v
      },
      expression: "authorInfo.verifyCode"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('img', {
    staticClass: "verify-code",
    attrs: {
      "src": _vm.getVerifyCode
    },
    on: {
      "click": _vm.getVerifyCodeSource
    }
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.nextStep('authorInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.commitToAudit')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "30px 0",
      "font-size": "12px",
      "color": "#ccc"
    }
  }, [_vm._v("温馨提示：如果您在申请入驻时，有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务。\n                            有声化平台官方邮箱：a.plus@ximalaya.com")])], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "disabled": _vm.userType === 1,
      "label": _vm.$t('comb.copyrightOrgnization'),
      "name": "publisherInfo"
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "publisherInfo",
    attrs: {
      "model": _vm.publisherInfo,
      "rules": _vm.publisherRules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.publisherName'),
      "prop": "name",
      "required": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.publisherNameMissing')
    },
    model: {
      value: (_vm.publisherInfo.name),
      callback: function($$v) {
        _vm.publisherInfo.name = $$v
      },
      expression: "publisherInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.licenseNumber'),
      "prop": "id",
      "required": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.licenseNumberPlaceHolder')
    },
    model: {
      value: (_vm.publisherInfo.id),
      callback: function($$v) {
        _vm.publisherInfo.id = $$v
      },
      expression: "publisherInfo.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.phoneNumber'),
      "prop": "phoneNumber",
      "required": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.phoneNumberPlaceHolder')
    },
    model: {
      value: (_vm.publisherInfo.phoneNumber),
      callback: function($$v) {
        _vm.publisherInfo.phoneNumber = $$v
      },
      expression: "publisherInfo.phoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('word.magnumOpus'),
      "prop": "curBook"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.bookBelongPlaceHolder')
    },
    model: {
      value: (_vm.publisherInfo.curBook),
      callback: function($$v) {
        _vm.publisherInfo.curBook = $$v
      },
      expression: "publisherInfo.curBook"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.emailAddress'),
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": _vm.$t('sen.emailPlaceHolder')
    },
    model: {
      value: (_vm.publisherInfo.email),
      callback: function($$v) {
        _vm.publisherInfo.email = $$v
      },
      expression: "publisherInfo.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.address'),
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": "您的联系地址"
    },
    model: {
      value: (_vm.publisherInfo.address),
      callback: function($$v) {
        _vm.publisherInfo.address = $$v
      },
      expression: "publisherInfo.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "pseudonym"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": "出版社的联络人"
    },
    model: {
      value: (_vm.publisherInfo.pseudonym),
      callback: function($$v) {
        _vm.publisherInfo.pseudonym = $$v
      },
      expression: "publisherInfo.pseudonym"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人电话",
      "prop": "contacterPhoneNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "large",
      "placeholder": "联系人电话"
    },
    model: {
      value: (_vm.publisherInfo.contacterPhoneNumber),
      callback: function($$v) {
        _vm.publisherInfo.contacterPhoneNumber = $$v
      },
      expression: "publisherInfo.contacterPhoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('sen.uploadLicensePic'),
      "required": true
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sen.pictureUploadLimit')))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "idPic"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "/api/upload/file",
      "type": "drag",
      "show-file-list": false,
      "before-upload": _vm.uploadBefore,
      "multiple": false,
      "v-model": _vm.publisherInfo.idPic,
      "accept": ".jpg, .png, .bmp",
      "on-success": _vm.uploadSuccess
    }
  }, [(_vm.publisherInfo.idPic) ? _c('img', {
    staticClass: "wrapper-upload-large",
    attrs: {
      "src": _vm.uploadedPic,
      "alt": ""
    }
  }) : _c('div', {
    staticClass: "wrapper-upload-large"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verifyCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('word.verifyCode')
    },
    model: {
      value: (_vm.publisherInfo.verifyCode),
      callback: function($$v) {
        _vm.publisherInfo.verifyCode = $$v
      },
      expression: "publisherInfo.verifyCode"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('img', {
    staticClass: "verify-code",
    attrs: {
      "src": _vm.getVerifyCode
    },
    on: {
      "click": _vm.getVerifyCodeSource
    }
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.nextStep('publisherInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.commitToAudit')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "30px 0",
      "font-size": "12px",
      "color": "#ccc"
    }
  }, [_vm._v("温馨提示：如果您在申请入驻时，有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务。\n                            有声化平台官方邮箱：a.plus@ximalaya.com")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('xi-footer'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": ("" + (_vm.$i18n.t('word.tips'))),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('sen.backToPrevPageConfirm')) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.$t('word.ok')))])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item active"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-02"
  }), _vm._v(" "), _c('span', [_vm._v("填写资料")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-prod-flow-03"
  }), _vm._v(" "), _c('span', [_vm._v("等待审核")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2af9ada1!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/Apply.vue
// module id = 1040
// module chunks = 0